import ApplicationController from '../application_controller.js'

export default class EntitiesController extends ApplicationController {

  displayForm(e) {
    e.preventDefault()
    this.fetch_partial("tab-partial-view", e.target.getAttribute("href"), "get", null)
  }

  submitForm(e) {
    e.preventDefault()
    this.fetch_partial("tab-partial-view", e.target.getAttribute("action"), e.target.getAttribute("method"), new FormData(e.target))
  }

  cancelForm(e) {
    e.preventDefault()
    this.fetch_partial("tab-partial-view", e.target.getAttribute("href"), "get", null)
  }

  showEntity(e) {
    e.preventDefault()
    this.fetch_partial("tab-partial-view", e.target.getAttribute("href"), "get", null)
  }

  destroyEntity(e) {
    e.preventDefault()
    this.fetch_partial("tab-partial-view", e.target.getAttribute("href"), "delete", null)
  }

}